import { Component, Input, output } from '@angular/core';
import { NotificationType } from '../ui-notification/models';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
  @Input() type: NotificationType;
  @Input() title: string;
  @Input() content: string;
  @Input() showClose = false;

  messageClose = output<void>();

  onClose(): void {
    this.messageClose.emit();
  }
}
